var path = 'infrastructure/directives/views/octo-paginator.html';
var html = "<div> <div ng-show=show> <ul class=pagination ng-if=!showAsLoadMore> <li ng-repeat=\"page in pages\" ng-class=\"{active: page.isActive}\"><a href=\"\" ng-click=\"onPageSelected(page.skip, page.index)\">{{ page.number }}</a></li> </ul> <div class=\"col-md-12 text-center\" ng-if=showAsLoadMore> <button class=\"btn btn-default\" ng-click=onLoadMore(skip)>Load more</button> <button class=\"btn btn-link\" ng-if=\"show && !!loadAll\" ng-click=onLoadAll()>Load all</button> </div> </div> </div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/infrastructure/directives/views/octo-paginator.html
// module id = 1023
// module chunks = 1